import { render } from "./EditSignDoc.vue?vue&type=template&id=6e83f1fa&scoped=true"
import script from "./EditSignDoc.vue?vue&type=script&lang=js"
export * from "./EditSignDoc.vue?vue&type=script&lang=js"

import "./EditSignDoc.vue?vue&type=style&index=0&id=6e83f1fa&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e83f1fa"]])

export default __exports__